import { WMSCapabilities } from 'ol/format';

type AuthorityURL = {
  OnlineResource: string;
  name: string;
};

type BoundingBox = {
  crs: string;
  extent: number[];
  res: (number | null)[];
};

type MetadataURL = {
  Format: string;
  OnlineResource: string;
  type: string;
};

type LegendURL = {
  Format: string;
  OnlineResource: string;
  size: number[];
};

type Style = {
  LegendURL: LegendURL[];
  Name: string;
  Title: string;
};

export type LayerInfo = {
  Abstract: string;
  AuthorityURL: AuthorityURL[];
  BoundingBox: BoundingBox[];
  CRS: string[];
  EX_GeographicBoundingBox: number[];
  MetadataURL: MetadataURL[];
  Name: string;
  Style: Style[];
  Title: string;
  noSubsets: boolean;
  opaque: boolean;
  queryable: boolean;
};

export const getCapabilities = (
  url: string
): Promise<{ layers: LayerInfo[]; version: string }> => {
  const urlObj = new URL(url);

  // Get the existing query parameters
  const params = urlObj.searchParams;

  // Add new parameters
  params.set('SERVICE', 'WMS');
  params.set('REQUEST', 'GetCapabilities');

  // Update the search query for the URL object
  urlObj.search = params.toString();

  // New URL with existing and new parameters
  const updatedUrl = urlObj.toString();

  return new Promise((resolve, reject) => {
    fetch(updatedUrl)
      .then((response) => response.text())
      .then((text) => {
        const parser = new WMSCapabilities();

        const capabilities = parser.read(text);
        if (capabilities) {
          const layers = capabilities.Capability.Layer.Layer;
          const version = capabilities.version || '';

          resolve({ layers, version });
        } else {
          reject(new Error('Failed to parse capabilities'));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
